import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Navbar from "../Navbar/navbar"
import Footer from "../Footer/footer"

const Layout = props => {
  const query = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "images/logo.png" }) {
        childImageSharp {
          fixed(width: 200) {
            ...GatsbyImageSharpFixed_withWebp_noBase64
          }
        }
      }
    }
  `)

  return (
    <React.Fragment>
      <Navbar logoImg={query.logo.childImageSharp.fixed} />
      {props.children}
      <Footer />
    </React.Fragment>
  )
}

export default Layout
